module.exports = __webpack_public_path__ + "img/zp1.794b5155.png";